<template>
<div class="chapter">
<div class="inner_page">
<div>
<p class="chapter-title1"><a id="page_xviii"></a><a id="page_xix"></a>ACKNOWLEDGMENTS</p>
<p class="body-text">In acknowledgment I would like to thank Jane Behnken and the very competent editorial staff and production team at Indiana University Press for their continued support and hard work throughout this project. My gratitude also goes to my friend and colleague Stewart Carter, editor of the first edition of this book, for his support of my undertaking this revised and expanded edition. I am deeply indebted to Herbert Myers for the painstaking care he took in reading over the entire manuscript. Were it not for his sharp eye and thoroughgoing understanding of the period under discussion, this book would not be what it is today. To my graduate assistants at The Florida State University College of Music, Matthew Henson and Christopher Phillpot, my thanks for their assistance in putting together the index—a tedious and time-consuming task, but one that will save readers a great deal of tedium and time when using this book. And finally, I wish to extend my appreciation to Early Music America for its belief in this series of Performance Practice Guides from its inception in the late 1980s. The unflagging advocacy and backing by this organization and its members have been instrumental in the great success the Guides have encountered.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// acknowledgments.vue?6df766d6